import React, { useState, useEffect, useContext } from 'react'
import { Form, Button, Container, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom'
import Message from '../components/Message'
import Loader from '../components/Loader'
import FormContainer from '../components/FormContainer'
import { getUserProfile, updateUserProfile } from '../actions/userActions'
import { USER_UPDATE_PROFILE_RESET } from '../constants/userConstants'
import { ThemeContext } from '../components/ThemeContext.js'

const ProfileScreen = () => {
  const { theme } = useContext(ThemeContext)

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })

  function showAlert(message, variant = 'success', seconds = 3000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userProfile = useSelector((state) => state.userProfile)
  const { loading, error, user } = userProfile

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile)
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success
  } = userUpdateProfile

  const panelStyle = {
    backgroundColor: theme.card,
    border: `1px solid ${theme.sidebarAccent}`,
    borderRadius: '12px',
    padding: '1.25rem'
  }

  const labelStyle = {
    color: theme.subtext
  }

  const inputStyle = {
    backgroundColor: theme.surfaceMuted,
    color: theme.text,
    borderColor: theme.sidebarAccent
  }

  useEffect(() => {
    if (!userInfo) {
      navigate('/login')
    } else {
      if (!user || !user.name) {
        dispatch(getUserProfile(userInfo._id))
      } else {
        setName(user.name)
        setEmail(user.email)
      }
    }
  }, [dispatch, navigate, userInfo, user])

  useEffect(() => {
    if (success) {
      showAlert('Password Updated')
      setPassword('')
      setConfirmPassword('')
      dispatch({ type: USER_UPDATE_PROFILE_RESET })
    }
  }, [dispatch, success])

  const submitHandler = (e) => {
    e.preventDefault()
    setMessage(null)

    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
    } else {
      dispatch(updateUserProfile({ id: user._id, name, email, password }))
    }
  }

  return (
    <Container className='mt-3' style={{ color: theme.text }}>
      {userInfo && userInfo.isAdmin && (
        <Link to='/admin/userlist' className='btn btn-outline-secondary my-3'>
          Go Back
        </Link>
      )}
      <FormContainer>
        <div style={panelStyle}>
          <h1 style={{ color: theme.text }}>Change Password</h1>
          {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
          {message && <Message variant='danger'>{message}</Message>}
          {loadingUpdate && <Loader />}
          {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
          {loading ? (
            <Loader />
          ) : error ? (
            <Message variant='danger'>{error}</Message>
          ) : (
            <Form onSubmit={submitHandler}>
              <Form.Group className='mb-2' controlId='name'>
                <Form.Label style={labelStyle}>Name</Form.Label>
                <Form.Control
                  readOnly
                  type='text'
                  placeholder='Enter name'
                  value={name}
                  style={inputStyle}
                ></Form.Control>
              </Form.Group>

              <Form.Group className='mb-2' controlId='email'>
                <Form.Label style={labelStyle}>Email Address</Form.Label>
                <Form.Control
                  readOnly
                  type='email'
                  placeholder='Enter email'
                  value={email}
                  style={inputStyle}
                ></Form.Control>
              </Form.Group>

              <Form.Group className='mb-2' controlId='password'>
                <Form.Label style={labelStyle}>Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Enter password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>

              <Form.Group className='mb-2' controlId='confirmPassword'>
                <Form.Label style={labelStyle}>Confirm Password</Form.Label>
                <Form.Control
                  type='password'
                  placeholder='Confirm password'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={inputStyle}
                />
              </Form.Group>

              <Button type='submit' className='btn btn-outline-primary my-3'>
                Update
              </Button>
            </Form>
          )}
        </div>
      </FormContainer>
    </Container>
  )
}

export default ProfileScreen
